import Datetime from 'utils/datetime/datetime'
import { getHourStepLabel, getUtcHourStart } from 'utils/datetime/dayTimeSteps'

export function getIntradayOptimizationWindow(
  now: number,
  optimizationPeriodHours: number
): { optStartTime: ISODateTime; optEndTime: ISODateTime } {
  const optStartTime = getUtcHourStart(now)
  return { optStartTime, optEndTime: Datetime.addHours(optStartTime, optimizationPeriodHours) }
}

export function getIntradayPriceStartTime(baseStartTime: Date, elapsedHourOffset: number): ISODateTime {
  return Datetime.addHours(Datetime.toISOString(baseStartTime), elapsedHourOffset)
}

export function formatIntradayHourLabel(start: ISODateTime): string {
  const end = Datetime.addHours(start, 1)
  const startDate = Datetime.toLocalTime(start, 'onlyDate')
  const endDate = Datetime.toLocalTime(end, 'onlyDate')
  if (startDate === endDate) {
    return `${startDate} ${getHourStepLabel(start)}`
  }

  const startHour = Datetime.toLocalTime(start, 'hour')
  const endHour = Datetime.toLocalTime(end, 'hour')
  return `${startDate} ${startHour} - ${endDate} ${endHour}`
}

export function createIntradayHourLabel(elapsedHourOffset: number, baseStartTime: Date): string {
  return formatIntradayHourLabel(getIntradayPriceStartTime(baseStartTime, elapsedHourOffset))
}
